import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';
import styles from './NominationModal.module.scss';

interface NominationErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  errorCode: string;
}

export const NominationErrorModal: React.VFC<NominationErrorModalProps> = ({
  isOpen,
  onClose,
  errorCode,
}) => {
  const { t } = useTranslation('nominations');
  let errorHeading = 'error_modal.generic_header';
  let errorText = 'error_modal.generic_text';
  let showBackButton = true;

  if (errorCode === 'DUPLICATE_NOMINATION') {
    errorHeading = 'error_modal.duplicate_nomination_header';
    errorText = 'error_modal.duplicate_nomination_text';
  } else if (errorCode === 'TOO_MANY_NOMINATIONS_FOR_NOMINATOR') {
    errorHeading = 'error_modal.too_many_nominations_header';
    errorText = 'error_modal.too_many_nominations_text';
    showBackButton = false;
  }

  return (
    <Modal open={isOpen} className={styles.container} onClose={onClose}>
      <div className={styles.modal}>
        <button className={styles.closeBtn} onClick={onClose}>
          <CloseIcon />
        </button>
        <h3 className={classnames(styles.header, styles.error)}>{t(errorHeading)}</h3>
        <p className={styles.text}>{t(errorText)}</p>
        {showBackButton && (
          <button className={styles.actionButton} onClick={onClose}>
            {t('error_modal.action_button')}
          </button>
        )}
      </div>
    </Modal>
  );
};
